import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Modal from "../../../components/ModalSuccessMessage";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";

import { Legend, ButtonContainer } from "./styles";

import routes from "../../../routes/configuration.routes";
import Main from "../../../components/Main/index";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Assets
import company from "../../../assets/icons/company.svg";
import bank from "../../../assets/icons/bank.svg";
import api from "../../../service/api";

const Password = () => {
    const [errorsOnSubmit, setErrorsOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    
    useEffect(() => {
        if(login.user.groups.mc6a3 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const searchForErrorsOnSubmit = (error: any) => {
        if(error !== {}){
            setErrorsOnSubmit(true)
        } else {
            setErrorsOnSubmit(false)
        }
    }

    const formValidationWithYup = Yup.object().shape({
        oldPassword: Yup.string().required(),
        newPassword: Yup.string().required(),
        repeatPassword: Yup.string().required()
    })

    return(
        <Main>
            <Header title="Configuração" subTitle="Altere as configurações gerais do sistema caso seja nescessário" subTitleWidth={271}/>
            <NavTabs tabs={routes}/>
            <Modal text="Senha alterada com Sucesso"/>

            <div className="row">
                {
                    login.user.groups.cm6a3u1 ?
                        <div className="col-12 col-lg-4 mr-5">
                            <Formik
                                initialValues={{
                                    oldPassword: "",
                                    newPassword: "",
                                    repeatPassword: ""
                                }}
                                validationSchema={formValidationWithYup}
                                onSubmit={async (values) => {
                                    if(values.newPassword === values.repeatPassword){
                                        try {
                                            const {data} = await api.put("/profile/update", {
                                                "name": login.user.name,
                                                "email": login.user.email,
                                                "old_password": values.oldPassword,
                                                "password": values.newPassword,
                                                "password_confirmation": values.repeatPassword
                                            });
                                            
                                            setErrorOnReturnApi(false);
                                            openModal("exampleModal");
                                        } catch (error) {
                                            setErrorOnReturnApi(true);
                                        }
                                    } else {

                                    }
                                }}
                            >
                                <Form>
                                    <fieldset>
                                        <Legend>
                                            <img src={company} style={{marginRight: 10}}/>
                                            Alterar senha de cadastro
                                        </Legend>
                                        
                                        <Field id="oldPassword" name="oldPassword" type="password" className="inputCustom" placeholder="Senha antiga" as={Input}/>
                                        <Field id="newPassword" name="newPassword" type="password" className="inputCustom" placeholder="Nova senha" as={Input}/>
                                        <Field id="repeatPassword" name="repeatPassword" type="password" className="inputCustom" placeholder="Repita a nova senha" as={Input}/>
                                        
                                        {
                                            errorOnReturnApi ? 
                                                <ErrorMessage>
                                                    Falha ao atualizar senha
                                                </ErrorMessage> : null
                                        }

                                        <ButtonContainer>
                                            <Button type="submit" >Alterar Senha</Button>
                                        </ButtonContainer>
                                    </fieldset>
                                </Form>    
                            </Formik>

                        </div> : null
                }
                {
                    login.user.groups.cm6a3u2 ?
                        <div className="col-12 pt-5 pt-lg-0 col-lg-4">
                            <fieldset>
                                <Legend>
                                    <img src={bank} style={{marginRight: 10}}/>
                                    Alterar senha de transferência
                                </Legend>
                                <form>
                                    <Input className="inputCustom" placeholder="Senha de transferência antiga"/>
                                    <Input className="inputCustom" placeholder="Nova senha de transferência"/>
                                    <Input className="inputCustom" placeholder="Repita a nova senha de transferência"/>
                                </form>
                                <ButtonContainer>
                                    <Button data-toggle="modal" data-target="#exampleModal">Alterar Senha</Button>
                                </ButtonContainer>
                            </fieldset>
                        </div> : null
                }
            </div>
        </Main>
    )
}

export default Password;